import {StyleSheet, View} from 'react-native'

import {type ChatWindowEntry} from '#/state/chat-bubble'
import {useTheme} from '#/alf'
import {ConvoInitializer} from '#/components/chat-bubble/ConvoInitializer'
import {FloatingChatHeader} from '#/components/chat-bubble/FloatingChatHeader'
import {FloatingConvoProvider} from '#/components/chat-bubble/FloatingConvoProvider'
import {FloatingMessagesList} from '#/components/chat-bubble/FloatingMessagesList'
import {PrivateRoomButton} from '#/components/chat-bubble/PrivateRoomButton'

export function FloatingChatWindow({window: win}: {window: ChatWindowEntry}) {
  const t = useTheme()

  return (
    <View
      style={[
        styles.window,
        win.isMinimized && styles.windowMinimized,
        t.atoms.bg,
        {
          borderColor: t.atoms.border_contrast_low.borderColor,
        },
      ]}>
      <FloatingChatHeader
        windowId={win.id}
        recipientProfile={win.recipientProfile}
        isMinimized={win.isMinimized}
      />
      {!win.isMinimized && (
        <>
          <PrivateRoomButton recipientDid={win.recipientDid} />
          <View style={styles.body}>
            {win.convoId ? (
            <FloatingConvoProvider
              convoId={win.convoId}
              isVisible={!win.isMinimized}>
              <FloatingMessagesList />
            </FloatingConvoProvider>
          ) : (
            <ConvoInitializer
              windowId={win.id}
              recipientDid={win.recipientDid}
            />
          )}
          </View>
        </>
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  window: {
    width: 340,
    height: 450,
    borderRadius: 10,
    borderWidth: 1,
    overflow: 'hidden',
    boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
    pointerEvents: 'auto',
  } as any,
  windowMinimized: {
    height: 'auto' as any,
  },
  body: {
    flex: 1,
  },
})
